import React, {
    ReactElement,
} from "react";
import { Form } from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import Editor from "react-simple-code-editor";
import Prism from "prismjs";
import BooleanSelect from "../../../../components/pickers/boolean/BooleanSelect";
import { Json } from "./base";
import Template from "./Template";
import Select from "../../../../components/select/Select";
import Styles from "./CreateService.module.scss";
import "prismjs/themes/prism.css";
import "prismjs/components/prism-markup-templating";
import "prismjs/components/prism-handlebars";

export function FunctionRawValue({
    json, onChange,
}: {
    json : Json ;
    onChange: (value: Json) => void;
}): ReactElement {
    if (json.string != null) {
        return (
            <Form.Group className="mb-2 me-2">
                <Form.Label className="fw-bolder">String Value</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="input.value"
                    required
                    value={json.string as string}
                    onChange={evt => {
                        onChange({
                            ...json,
                            string: evt.target.value,
                        });
                    }}
                />
                <Form.Text>
                    The string value
                </Form.Text>
            </Form.Group>
        );
    }
    if (json.boolean != null) {
        return (
            <Form.Group className="mb-2 me-2">
                <Form.Label className="fw-bolder">Boolean Value</Form.Label>
                <BooleanSelect
                    value={json.boolean as boolean}
                    onChange={value => {
                        onChange({
                            ...json,
                            boolean: value,
                        });
                    }}
                />

                <Form.Text>
                    The string value
                </Form.Text>
            </Form.Group>
        );
    }
    if (json.date != null) {
        return (
            <Form.Group className="mb-2 me-2">
                <Form.Label className="fw-bolder">Date Value</Form.Label>
                <Form.Control
                    type="datetime-local"
                    placeholder="input.value"
                    required
                    value={json.date as string}
                    onChange={evt => {
                        onChange({
                            ...json,
                            date: evt.target.value,
                        });
                    }}
                />

                <Form.Text>
                    The string value
                </Form.Text>
            </Form.Group>
        );
    }
    if (json.number != null) {
        return (
            <Form.Group className="mb-2 me-2">
                <Form.Label className="fw-bolder">Number Value</Form.Label>
                <Form.Control
                    type="number"
                    placeholder="input.value"
                    required
                    value={json.number as string}
                    onChange={evt => {
                        onChange({
                            ...json,
                            number: evt.target.value,
                        });
                    }}
                />

                <Form.Text>
                    The numeric value
                </Form.Text>
            </Form.Group>
        );
    }
    if (json.options != null) {
        return (
            <Form.Group className="mb-2 me-2">
                <Form.Label className="fw-bolder">Options Value</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="input.value"
                    as="textarea"
                    required
                    value={(json.options as string[])?.join("\n") as string}
                    onChange={evt => {
                        onChange({
                            ...json,
                            options: evt.target.value?.split("\n"),
                        });
                    }}
                />

                <Form.Text>
                    The string value
                </Form.Text>
            </Form.Group>
        );
    }
    return (
        <div className="mt-3">

            <div>
                <Form.Label className="fw-bolder">Raw Type</Form.Label>

                <div className="w-100">
                    <button
                        type="button"
                        onClick={() => onChange({ ...json, string: "" })}
                        className="btn btn-primary btn-sm"
                    >
                        String
                    </button>

                    <button
                        type="button"
                        onClick={() => onChange({ ...json, boolean: false })}
                        className="btn btn-primary btn-sm"
                    >
                        Boolean
                    </button>

                    <button
                        type="button"
                        onClick={() => onChange({ ...json, date: new Date() })}
                        className="btn btn-primary btn-sm"
                    >
                        Date
                    </button>

                    <button
                        type="button"
                        onClick={() => onChange({ ...json, number: 0 })}
                        className="btn btn-primary btn-sm"
                    >
                        Number
                    </button>

                    <button
                        type="button"
                        onClick={() => onChange({ ...json, options: [] })}
                        className="btn btn-primary btn-sm"
                    >
                        Options
                    </button>

                </div>

            </div>

        </div>
    );
}

export function FunctionValue({
    json, onChange,
}: {
    json : Json;
    onChange: (value: Json) => void;
}): ReactElement {
    return (
        <div>
            {json.path != null && (
                <Form.Group className="mb-2 me-2">
                    <Form.Label className="fw-bolder">Path</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="input.value"
                        required
                        value={json.path as string}
                        onChange={evt => {
                            onChange({
                                ...json,
                                path: evt.target.value,
                            });
                        }}
                    />
                    <Form.Text>
                        The path field
                    </Form.Text>
                </Form.Group>
            )}

            {json.defaultValue != null && (
                <Form.Group className="mb-2 me-2">
                    {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
                    <Function
                        title="Default Value"
                        json={json.defaultValue as Json}
                        onChange={defaultValue => onChange({ ...json, defaultValue })}
                    />
                    <Form.Text>
                        The default value
                    </Form.Text>
                </Form.Group>
            )}

            {json.functions != null && (
                <Form.Group className="mb-2 me-2">
                    {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
                    <FunctionArray
                        title="Functions"
                        json={{ values: json.functions }}
                        onChange={functions => onChange({ ...json, functions: functions.values })}
                    />
                    <Form.Text>
                        The path field
                    </Form.Text>
                </Form.Group>
            )}

            {json.pathTemplate != null && (
                <Template
                    json={json.pathTemplate as Json}
                    onChange={pathTemplate => onChange({ ...json, pathTemplate })}
                />
            )}
            {json.value != null && (
                <FunctionRawValue
                    json={json.value as Json}
                    onChange={value => onChange({ ...json, value })}
                />
            )}

            <div>
                <Form.Label className="fw-bolder">Value Types</Form.Label>

                <div className="w-100">
                    {json.path == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, path: "" })}
                            className="btn btn-primary btn-sm"
                        >
                            Path
                        </button>
                    )}
                    {json.value == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, value: {} })}
                            className="btn btn-primary btn-sm"
                        >
                            Value
                        </button>
                    )}

                    {json.functions == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, functions: [] })}
                            className="btn btn-primary btn-sm"
                        >
                            Functions
                        </button>
                    )}

                    {json.pathTemplate == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, pathTemplate: {} })}
                            className="btn btn-primary btn-sm"
                        >
                            Path Template
                        </button>
                    )}

                    {json.defaultValue == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, defaultValue: {} })}
                            className="btn btn-primary btn-sm"
                        >
                            Default Value
                        </button>
                    )}

                </div>

            </div>
        </div>

    );
}

export function FunctionExecuteTemplate({
    json, onChange,
}: {
    json : Json;
    onChange: (value: Json) => void;
}): ReactElement {
    const list = json.templates as Json[] ?? [];
    return (
        <div className="w-100">

            <div>
                <button
                    type="button"
                    onClick={() => {
                        list.push({});
                        onChange({
                            templates: list,
                        });
                    }}
                    className="btn btn-primary btn-sm px-2 py-1"
                >
                    Add Template
                </button>
            </div>

            <ul className="list-group">
                {list.map((value, index) => (
                    <li className="list-group-item d-flex justify-content-between align-items-start border-0 p-0">

                        <div className="flex-grow-1  border p-3">

                            <Editor
                                value={value?.template as string}
                                highlight={code => {
                                    const highlighted = code
                                        ? Prism.highlight(code, Prism.languages.handlebars, "handlebars")
                                        : undefined;
                                    return highlighted;
                                }}
                                className={`${Styles["template-block"]}`}
                                tabSize={4}
                                onValueChange={code => {
                                    list[index].template = code;
                                    onChange({
                                        templates: list,
                                    });
                                }}
                            />
                            <div>
                                <Form.Check
                                    onChange={evt => {
                                        const copy = [...list];
                                        copy[index].shouldParseJson = evt.target.checked;
                                        onChange({
                                            templates: copy,
                                        });
                                    }}
                                    checked={value.shouldParseJson as boolean ?? true}
                                    label="Should parse to Json"
                                />
                            </div>
                        </div>
                        <div>

                            <button
                                className="btn btn-sm btn-none"
                                type="button"
                                onClick={() => {
                                    list.splice(index, 1);

                                    onChange({
                                        templates: list,
                                    });
                                }}
                            >
                                <BiTrash className="text-light" />
                            </button>

                        </div>

                    </li>
                ))}

            </ul>
        </div>

    );
}

export function FunctionArray({
    json, onChange, title,
}: {
    json : Json;
    onChange: (value: Json) => void;
    title?: string
}): ReactElement {
    const list = json.values as Json[];
    return (
        <div className="w-100">

            <div>
                <strong className="d-block">{title}</strong>
                <button
                    type="button"
                    onClick={() => onChange({ ...json, values: [...list, {}] })}
                    className="btn btn-primary btn-sm px-2 py-1"
                >
                    Add
                </button>
            </div>

            <ul className="list-group">
                {list?.map((value, index) => (
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div className="flex-grow-1">
                            {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
                            <Function
                                json={value}
                                onChange={(newValue: Json) => {
                                    const copy = {
                                        ...json,
                                    };
                                    copy.values ??= [];
                                    (copy.values as Json[])[index] = newValue;

                                    onChange(copy);
                                }}
                            />
                        </div>
                        <div>

                            <button
                                className="btn btn-sm btn-none"
                                type="button"
                                onClick={() => {
                                    const copy = {
                                        ...json,
                                    };
                                    (copy.values as Json[]).splice(index, 1);

                                    onChange(copy);
                                }}
                            >
                                <BiTrash className="text-light" />
                            </button>

                        </div>

                    </li>
                ))}

            </ul>
        </div>

    );
}
FunctionArray.defaultProps = {
    title: "Array Values",
};

export function FunctionObject({
    json, onChange, title,
}: {
    json : Json;
    onChange: (value: Json) => void;
    title?: string
}): ReactElement {
    const list = json.values as Json[];
    return (
        <div className="w-100">

            <div>
                <strong className="d-block">{title}</strong>
                <button
                    type="button"
                    onClick={() => onChange({ ...json, values: [...list, {}] })}
                    className="btn btn-primary btn-sm px-2 py-1"
                >
                    Add
                </button>
            </div>

            <ul className="list-group w-100">
                {list?.map((value, index) => (
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div className="d-flex  flex-grow-1">
                            <Form.Group className="mb-2 me-2">
                                <Form.Label className="fw-bolder">Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Name"
                                    required
                                    value={value.name as string}
                                    onChange={evt => {
                                        const copy = {
                                            ...json,
                                        };
                                        copy.values ??= [];
                                        const current = (copy.values as Json[])[index];
                                        (copy.values as Json[])[index] = {
                                            ...current,
                                            name: evt.target.value,
                                        };

                                        onChange(copy);
                                    }}
                                />
                                <Form.Text>
                                    The name of the field
                                </Form.Text>
                            </Form.Group>

                            {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
                            <Function
                                json={value.function as Json ?? {}}
                                onChange={(newValue: Json) => {
                                    const copy = {
                                        ...json,
                                    };
                                    copy.values = [...((copy.values ?? []) as Json[])];
                                    const current = (copy.values as Json[])[index];
                                    (copy.values as Json[])[index] = {
                                        ...current,
                                        function: newValue,
                                    };

                                    onChange(copy);
                                }}
                            />
                        </div>

                        <button
                            className="btn btn-sm btn-none"
                            type="button"
                            onClick={() => {
                                const copy = {
                                    ...json,
                                };
                                (copy.values as Json[]).splice(index, 1);

                                onChange(copy);
                            }}
                        >
                            <BiTrash className="text-light" />
                        </button>

                    </li>
                ))}

            </ul>
        </div>

    );
}
FunctionObject.defaultProps = {
    title: "Object Values",
};

export function FunctionMap({
    json, onChange,
}: {
    json : Json;
    onChange: (value: Json) => void;
}): ReactElement {
    return (
        <div>
            {json.path != null && (
                <Form.Group className="mb-2 me-2">
                    <Form.Label className="fw-bolder">Path</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="input.value"
                        required
                        value={json.path as string}
                        onChange={evt => {
                            onChange({
                                ...json,
                                path: evt.target.value,
                            });
                        }}
                    />
                    <Form.Text>
                        The path field
                    </Form.Text>
                </Form.Group>
            )}
            {json.paths != null && (
                <Form.Group className="mb-2 me-2">
                    <Form.Label className="fw-bolder">Paths</Form.Label>
                    <Form.Control
                        type="text"
                        as="textarea"
                        placeholder="input.value"
                        required
                        value={(json.paths as Json[])?.join("\n")}
                        onChange={evt => {
                            onChange({
                                ...json,
                                paths: evt.target.value.split("\n"),
                            });
                        }}
                    />
                    <Form.Text>
                        The paths field
                    </Form.Text>
                </Form.Group>
            )}

            {json.function != null && (
                <Form.Group className="mb-2 me-2">
                    {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
                    <Function
                        title="Function"
                        json={json.function as Json}
                        onChange={value => onChange({ ...json, function: value })}
                    />
                    <Form.Text>
                        The function
                    </Form.Text>
                </Form.Group>
            )}
            {json.functions != null && (
                <Form.Group className="mb-2 me-2">
                    {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
                    <FunctionArray
                        title="Functions"
                        json={{ values: json.functions }}
                        onChange={functions => onChange({ ...json, functions: functions.values })}
                    />
                    <Form.Text>
                        The path field
                    </Form.Text>
                </Form.Group>
            )}

            {json.join != null && (
                <Form.Group className="mb-2 me-2">
                    <Form.Label className="fw-bolder">Join Character</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="input.value"
                        required
                        value={(json.join as Json)?.character as string}
                        onChange={evt => {
                            onChange({
                                ...json,
                                join: {
                                    ...(json.join as Json),
                                    character: evt.target.value,
                                },
                            });
                        }}
                    />
                    <Form.Text>
                        The path field
                    </Form.Text>
                </Form.Group>
            )}

            <div>
                <Form.Label className="fw-bolder">Value Types</Form.Label>

                <div className="w-100">
                    {json.path == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, path: "" })}
                            className="btn btn-primary btn-sm"
                        >
                            Path
                        </button>
                    )}
                    {json.paths == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, paths: [] })}
                            className="btn btn-primary btn-sm"
                        >
                            Paths
                        </button>
                    )}

                    {json.function == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, function: {} })}
                            className="btn btn-primary btn-sm"
                        >
                            Function (deprecated)
                        </button>
                    )}
                    {json.functions == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, functions: [] })}
                            className="btn btn-primary btn-sm"
                        >
                            Functions
                        </button>
                    )}

                    {json.join == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, join: {} })}
                            className="btn btn-primary btn-sm"
                        >
                            Join
                        </button>
                    )}

                </div>

            </div>
        </div>

    );
}

const MODIFIERS = [

    {
        label: "Camel Case",
        value: "CAMEL_CASE",
    },
    {
        label: "Darwin Case",
        value: "DARWIN_CASE",
    },
    {
        label: "Pascal Case",
        value: "PASCAL_CASE",
    },
    {
        label: "Snake Case",
        value: "SNAKE_CASE",
    },
    {
        label: "Uppercase",
        value: "UPPER_CASE",
    },
    {
        label: "Lowecase",
        value: "LOWER_CASE",
    },
    {
        label: "Convert to base 64",
        value: "BASE_64",
    },
    {
        label: "Conver to Hex",
        value: "HEX",
    },
];

export function FunctionString({
    json, onChange,
}: {
    json : Json;
    onChange: (value: Json) => void;
}): ReactElement {
    const selectedModifier = MODIFIERS.find(modifier => modifier.value === json.modifier);
    return (
        <div>
            {json.path != null && (
                <Form.Group className="mb-2 me-2">
                    <Form.Label className="fw-bolder">Modifier</Form.Label>
                    <Select
                        onChange={modifier => onChange({
                            ...json,
                            modifier,
                        })}
                        value={!selectedModifier ? undefined : {
                            label: selectedModifier.label,
                            value: selectedModifier.value,
                        }}
                        options={MODIFIERS}
                    />
                    <Form.Text>
                        The modifier to apply
                    </Form.Text>
                </Form.Group>
            )}

            {json.split != null && (
                <Form.Group className="mb-2 me-2">
                    <Form.Label className="fw-bolder">Join Split</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="input.value"
                        required
                        value={(json.split as Json)?.character as string}
                        onChange={evt => {
                            onChange({
                                ...json,
                                split: {
                                    ...(json.split as Json),
                                    character: evt.target.value,
                                },
                            });
                        }}
                    />
                    <Form.Text>
                        The path field
                    </Form.Text>
                </Form.Group>
            )}

            <div>
                <Form.Label className="fw-bolder">Value Types</Form.Label>

                <div className="w-100">
                    {json.path == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, path: "" })}
                            className="btn btn-primary btn-sm"
                        >
                            Path
                        </button>
                    )}

                    {json.split == null && (
                        <button
                            type="button"
                            onClick={() => onChange({ ...json, split: {} })}
                            className="btn btn-primary btn-sm"
                        >
                            Split
                        </button>
                    )}

                </div>

            </div>
        </div>

    );
}

export function FunctionReplace({
    json, onChange,
}: {
    json : Json;
    onChange: (value: Json) => void;
}): ReactElement {
    return (
        <div>
            <Form.Group className="mb-2 me-2">
                <Form.Label className="fw-bolder">Find</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="RegExp to find"
                    required
                    value={json.find as string}
                    onChange={evt => {
                        onChange({
                            ...json,
                            find: evt.target.value,
                        });
                    }}
                />
                <Form.Text>
                    What to find. Can use RegExp
                </Form.Text>
            </Form.Group>

            <Form.Group className="mb-2 me-2">
                <Form.Label className="fw-bolder">Flags</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="ig"
                    value={json.flags as string}
                    onChange={evt => {
                        onChange({
                            ...json,
                            flags: evt.target.value,
                        });
                    }}
                />
                <Form.Text>
                    Flags to apply to the regular expression
                </Form.Text>
            </Form.Group>

            <Form.Group className="mb-2 me-2">
                <Form.Label className="fw-bolder">Replace</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Text to replace"
                    value={json.replace as string}
                    onChange={evt => {
                        onChange({
                            ...json,
                            replace: evt.target.value,
                        });
                    }}
                />
                <Form.Text>
                    What to replace the text with
                </Form.Text>
            </Form.Group>

        </div>

    );
}

export default function Function({
    json, onChange, title,
}: {
    json : Json;
    onChange: (value: Json) => void;
    title?: string;
}): ReactElement {
    if (json.array) {
        return (
            <FunctionArray json={json?.array as Json} onChange={array => onChange({ ...json, array })} />
        );
    }

    if (json.object) {
        return (
            <FunctionObject json={json?.object as Json} onChange={value => onChange({ ...json, object: value })} />
        );
    }

    if (json.value) {
        return (
            <FunctionValue json={json?.value as Json} onChange={value => onChange({ ...json, value })} />
        );
    }

    if (json.template) {
        return (
            <Template json={json?.template as Json} onChange={template => onChange({ ...json, template })} />
        );
    }

    if (json.map) {
        return (
            <FunctionMap json={json?.map as Json} onChange={mapData => onChange({ ...json, map: mapData })} />
        );
    }

    if (json.string) {
        return (
            <FunctionString json={json?.string as Json} onChange={mapData => onChange({ ...json, string: mapData })} />
        );
    }
    if (json.replace) {
        return (
            <FunctionReplace json={json?.replace as Json} onChange={replace => onChange({ ...json, replace })} />
        );
    }
    if (json.executeTemplate) {
        return (
            <FunctionExecuteTemplate
                json={json?.executeTemplate as Json}
                onChange={executeTemplate => onChange({ ...json, executeTemplate })}
            />
        );
    }

    return (
        <div>
            <Form.Label className="fw-bolder">{title}</Form.Label>

            <div className="d-flex">
                <button
                    type="button"
                    onClick={() => onChange({ ...json, array: { values: [] } })}
                    className="btn btn-primary btn-sm"
                >
                    Array
                </button>
                <button
                    type="button"
                    onClick={() => onChange({ ...json, object: { values: [] } })}
                    className="btn btn-primary btn-sm"
                >
                    Object
                </button>
                <button
                    type="button"
                    onClick={() => onChange({ ...json, value: {} })}
                    className="btn btn-primary btn-sm"
                >
                    Value
                </button>
                <button
                    type="button"
                    onClick={() => onChange({ ...json, template: {} })}
                    className="btn btn-primary btn-sm"
                >
                    Template
                </button>
                <button
                    type="button"
                    onClick={() => onChange({ ...json, map: {} })}
                    className="btn btn-primary btn-sm"
                >
                    Map
                </button>
                <button
                    type="button"
                    onClick={() => onChange({ ...json, string: {} })}
                    className="btn btn-primary btn-sm"
                >
                    String
                </button>
                <button
                    type="button"
                    onClick={() => onChange({ ...json, replace: {} })}
                    className="btn btn-primary btn-sm"
                >
                    Replace
                </button>
                <button
                    type="button"
                    onClick={() => onChange({ ...json, executeTemplate: {} })}
                    className="btn btn-primary btn-sm"
                >
                    Execute Templates
                </button>
            </div>
        </div>
    );
}

Function.defaultProps = {
    title: "Functions",
};
